<div class="tab-content" id="OemPortalTabs">
  <!-- Tab 1 - Enter Model SKU Info -->
  <div class="tab-pane fade show active" id="enterModelInfoTab">
    <div class="d-flex flex-column h-100">
      <!-- Data heading and info -->
      <div id="modelInfoHeader" class="data_header">
        <div id="modelInfoHeaderLeftSec" class="left_side_section">
          <div class="results_info">
            <div id="modelInfoTitle" class="title"><span i18n="@@model-sku-info.title.modelskus">Model SKUs</span></div>
            <div id="modelInfoLength" class="results"><span i18n="@@model-sku-info.pagination.showing">Showing <strong>
                  {{showFrom}} - {{showTo}} </strong> of
                <strong> {{modelSkuList?.length}} Model SKUs</strong></span>
            </div>
          </div>
          <div id="modelSKUSearchGroup" class="search_group" *ngIf="hasData">
            <div id="modelSKUSearchInput" class="input-group">
              <input type="text" id="modelSKUSearch" class="form-control" #searchValue [(ngModel)]="systemID"
                placeholder="{{searchPlaceholder}}" (keyup.enter)="searchDataOnEnter(systemID)" />
              <img class="search-clear-icon" alt="{{closeAlt}}" *ngIf="searchClose && systemID?.length"
                (click)="clearSearch()" />
            </div>
            <button type="button" class="btn btn-primary search_btn gtmModelSKUSearch" (click)="searchData(systemID)">
              <img class="search_icon" alt="{{searchAlt}}" />
            </button>
          </div>
          <iposcen-spinner-overlay></iposcen-spinner-overlay>
        </div>
        <div id="modelSKUActionBtn" class="action_buttons" *ngIf="hasData">
          <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmNewModelSKU"
            (click)="createNewModelSKU()">
            <!--  -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {{newModelSKUButton}}
          </button>
        </div>
      </div>
      <hr />

      <div id="noRecordFound" class="no-record" *ngIf='noDataOnSearch'>
        <span i18n="@@model-sku-info.screenmsg.norecord">No Records Found</span>
      </div>
      <div id="emptyScreenMsg" class="empty_screen_msg" *ngIf="!hasData">
        <span>
          <div>To begin creating partner content or Attract Loop Video to display on <div>your device,
              first enter the Model SKU Info of your device:</div>
          </div>
        </span>
        <div id="emptyScreenBtn" class="emptyScreen_button">
          <button type="button" class="btn btn-primary btn-lg left_icon_btn addButton gtmNewModelSKU"
            (click)="createNewModelSKU()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {{newModelSKUButton}}
          </button>
        </div>
      </div>

      <!-- Table data -->
      <div id="modelSKUData" *ngIf="hasData && !noDataOnSearch">
        <div id="modelSKUDataTable" class="table-responsive">
          <table id="modelSKUsTable" aria-describedby="Model SKU table" class="table table-borderless">
            <thead>
              <tr>
                <th scope="col">
                  <span class="table_headings" (click)="sort('systemID')">
                    <span i18n="@@model-sku-info.table.systemid">System ID</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings">
                    <span i18n="@@model-sku-info.table.systemmodel">System Models</span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('detectionStatus')">
                    <span i18n="@@model-sku-info.table.status">Status</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('displayName')">
                    <span i18n="@@model-sku-info.table.displayname">English Display Name</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('updatedTime')">
                    <span i18n="@@model-sku-info.table.lastupdated">Last Updated</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
                <th scope="col">
                  <span class="table_headings" (click)="sort('editedByName')">
                    <span i18n="@@model-sku-info.table.lastupdatedby">Last Updated By</span>
                    <span class="chevron_expand"></span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody *ngIf="hasData && !noDataOnSearch">
              <ng-container *ngFor="let item of modelSkuList | slice: (page-1) * tableSize : page * tableSize">
                <tr>
                  <td>{{item.systemID}}</td>


                  <td *ngIf="checkIfList(item.systemModels)">{{item.systemModels}}</td>
                  <td *ngIf="!checkIfList(item.systemModels)">
                    <span *ngIf="item.systemModels[2]==='tooltip'" [ngbTooltip]="item.systemModels[1]">
                      {{item.systemModels[0]}}
                    </span>

                    <span
                      *ngIf="item.systemModels[2]==='popup1' || item.systemModels[2]==='popup2'">{{item.systemModels[0]}}</span>

                    <span *ngIf="item.systemModels[2]==='popup1'" [ngbPopover]='popUp' class="popup-badge"
                      [popoverTitle]="item.systemModels[1].length + ' System Models'" placement="right">
                      +{{item.systemModels[1].length - 1 }} </span>
                    <span *ngIf="item.systemModels[2]==='popup2'" [ngbPopover]='popUp' class="popup-badge"
                      [popoverTitle]="item.systemModels[1].length + ' System Models'" placement="right">
                      +{{item.systemModels[1].length - 2 }} </span>
                  </td>
                  <ng-template #patternConflictPopup>
                    <span i18n="@@model-sku-info.pattern-conflict-error-msg.system-model-is-conflicting-pattern-conflict">The System Model Pattern is conflicting with {{item?.conflictingModelId}}. The System Model pattern should be unique</span>
                  </ng-template>
                  <ng-template #popUp>
                    <div>
                      <div
                        [ngClass]="{'popup-size-scroll':item.systemModels[1].length>5,'popup-size':item.systemModels[1].length<=5}">
                        <ul class='reduceLeftPad' *ngFor='let popupList of item.systemModels[1]'>
                          <li class="child">{{popupList}}</li>
                        </ul>
                      </div>
                    </div>
                  </ng-template>
                  <td>
                    <div class="status_column">
                      <em *ngIf="item.detectionStatus === 'approved'" class="approved_icon"></em>
                      <em *ngIf="item.detectionStatus === 'submitted'" class="submitted_icon"></em>
                      <em *ngIf="item.detectionStatus === 'returned'" class="returned_icon"></em>
                      <em *ngIf="item.detectionStatus === 'delete requested'" class="delete_req_icon"></em>
                      <span>{{checkCase(item.detectionStatus)}}</span>
                      <img *ngIf="item.detectionStatus === 'approved'" class="info_circle_icon" placement="top"
                        [popoverTitle]="approvepop" [ngbPopover]= "oemConst.APPROVED_POPOVER_TXT"
                        container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'submitted'" class="info_circle_icon" placement="top"
                        [popoverTitle]="submitpop"
                        [ngbPopover]="oemConst.SUBMITTED_POPOVER_TXT"
                        container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'delete requested'" class="info_circle_icon" placement="top"
                        [popoverTitle]="deleteReqPopUp" [ngbPopover]="oemConst.DELETED_POPOVER_TXT"
                        container="body" alt="delete requested" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'returned' && item.errorCode === 'EXISTS'"
                        class="info_circle_icon" placement="top" [popoverTitle]="returnpop"
                        [ngbPopover]="oemConst.RETURNED_EXISTS_POPOVER_TXT"
                        container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'returned' && item.errorCode === 'NOT_FOUND'"
                        class="info_circle_icon" placement="top" [popoverTitle]="returnpop"
                        [ngbPopover]="oemConst.RETURNED_NOT_FOUND_POPOVER_TXT"
                        container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'returned' && item.errorCode === 'PATTERN_CONFLICT'"
                        class="info_circle_icon" placement="top" [popoverTitle]="returnpop"
                        [ngbPopover]="patternConflictPopup" container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'returned' && item.errorCode === 'VALIDATION'"
                        class="info_circle_icon" placement="top" [popoverTitle]="returnpop"
                        [ngbPopover]="oemConst.RETURNED_VALIDATION_POPOVER_TXT"
                        container="body" alt="" triggers="mouseenter:mouseleave" />
                      <img *ngIf="item.detectionStatus === 'returned' && item.errorCode === 'ERROR'"
                        class="info_circle_icon" placement="top" [popoverTitle]="returnpop"
                        [ngbPopover]="oemConst.RETURNED_ERROR_POPOVER_TXT" container="body" alt=""
                        triggers="mouseenter:mouseleave" />
                    </div>
                  </td>
                  <td *ngIf="checkIfList(item.displayName)">{{item.displayName}}</td>
                  <td>{{item.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                  <td>{{item.editedByName}}</td>
                  <td class="action_cell">
                    <span class="edit_record" (click)="editSKU(item.autoID)">
                      <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="editTooltip" class="edit_icon"
                        alt="edit" />
                    </span>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>
      <hr *ngIf="hasData && !noDataOnSearch" />
      <ng-template #approvepop>
        <div id="approvedText" class="d-flex"><em class="approved_icon mr-2"></em>
          <span i18n="@@model-sku-info.template.approved">Approved</span>
        </div>

      </ng-template>
      <ng-template #submitpop>
        <div id="submittedText" class="d-flex"><em class="submitted_icon mr-2"></em>
          <span i18n="@@model-sku-info.template.submitted">Submitted</span>
        </div>

      </ng-template>
      <ng-template #returnpop>
        <div id="returnedText" class="d-flex"><em class="returned_icon mr-2"></em>
          <span i18n="@@model-sku-info.template.returned">Returned</span>
        </div>

      </ng-template>
      <ng-template #deleteReqPopUp>
        <div id="DeleteReqText" class="d-flex"><em class="delete_req_icon mr-2"></em>
          <span>Delete Requested</span>
        </div>
      </ng-template>
      <!-- Pagination -->
      <div id="modelSkuDataFooter" class="data_footer position-relative" *ngIf="hasData && !noDataOnSearch">
        <button *ngIf="modelSkuList?.length" type="button"
          class="btn btn-outline-primary left_icon_btn download_btn gtmUsersStoresDownloadCSV"
          (click)="downloadModelSkuCsvFile()">
          <img class="downloadbtn" alt="download" />
          <span i18n="@@stores.store-user.download-csv">Download CSV</span>
        </button>
        <span *ngIf="modelSkuList?.length" [ngbPopover]="downloadPopupContent" class="infoIcon"
          triggers="mouseenter:mouseleave">
          <span class="round-info-icon"></span>
        </span>
        <div id="modelSkuPagination" class="d-flex flex-column align-items-center">
          <nav aria-label="Model SKUs pagination">
            <ngb-pagination [collectionSize]="modelSkuList?.length" [(page)]="page" [pageSize]="tableSize"
              [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
              (pageChange)="onTableDataChange($event)">
            </ngb-pagination>
          </nav>
          <div id="modelSkuList" class="results mt-2"><span i18n="@@model-sku-info.pagination.showing">Showing <strong>
                {{showFrom}} - {{showTo}} </strong> of
              <strong> {{modelSkuList?.length}} Model SKUs</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>